import { render } from "./ListeTypeActeurPage.vue?vue&type=template&id=a97765d4&ts=true"
import script from "./ListeTypeActeurPage.vue?vue&type=script&lang=ts"
export * from "./ListeTypeActeurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__